import React from 'react';

require('./successpopup.scss');

class SuccessPopup extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { message: '' };

    this.hello = this.hello.bind(this);
    this.close = this.close.bind(this);
  }

  hello(message) {
    this.setState({
      message,
    });
  }

  close() {
    this.setState({
      message: '',
    });
  }

  render() {
    return (
      <div id="successPopup" className={this.state.message ? 'flex' : 'hidePop'}>
        <div className="modal">
          <div>
            {this.state.message !== '' ? (
              <svg width={72} height={72} className="iconOrderSuccess">
                <g fill="none" stroke="#0CD428" strokeWidth={2}>
                  <circle cx={36} cy={36} r={35} style={{ strokeDasharray: '240px, 240px', strokeDashoffset: 480 }} />
                  <path d="M17.417 37.778l9.93 9.91L52.79 22.293" style={{ strokeDasharray: '50px, 50px', strokeDashoffset: 0 }} />
                </g>
              </svg>
            ) : (
              <span />
            )}
            <div className="successTitle">{this.state.message}</div>
          </div>
          <div className="buttonHolder">
            <div className="buttonCart" onClick={this.close} role="button" tabIndex="0" style={{ outline: 'none' }}>
              {' '}
              {this.props.commonTranslations.goback}
              {' '}
            </div>
            <a href="/cart/summary/" data-cta="add-to-cart-microsite">
              <div className="buttonCart">
                {' '}
                {this.props.commonTranslations.checkouttext}
                {' '}
              </div>
            </a>
          </div>

        </div>
      </div>
    );
  }
}

export default SuccessPopup;
